import * as model from "@/model/prd/productionReport/dayReport/DayPelletizingProductionQualityItem";
import { newEntityStoreHelper } from "@/store/common/entityModule";



function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}


export default newEntityStoreHelper(() => new model.DayPelletizingProductionQualityItem(), newFilter)
    .withStates({
        idReport: 2,

        baseModuleUrl: process.env.VUE_APP_PRODUCTION_API_URL + "production-service/prd"
    }) //TODO load at the application start  
    .withActions({
      getDetails(context, id) {
            
            
        context.dispatch("api/get", {
                url: context.state.baseModuleUrl + "/dayPelletizingProductionQuality" + "/findById/" + id
            }, {
                root: true
            })
            .then(response => {
                {     
                    context.commit('dayPelletizingProductionQualityItem' + "/setRows", response.dayPelletizingProductionQualityItems, {
                        root: true
                    });

                }
            });
    },

    }) 
    .buildStore()